import { useEffect, useRef } from 'react';

export const useFocusTrap = () => {
    const ref = useRef(null);
    useEffect(() => {
        ref.current.focus();
        const handleFocusTrap = (e) => {
            if (!ref.current.contains(e.target)) {
                ref.current.focus();
            }
        };
        document.addEventListener('focus', handleFocusTrap, true);
        return () => {
            document.removeEventListener('focus', handleFocusTrap, true);
        };
    }, []);
    return ref;
};
